import { render, staticRenderFns } from "./OurValuesShapeThree.vue?vue&type=template&id=564711e4&"
import script from "./OurValuesShapeThree.vue?vue&type=script&lang=js&"
export * from "./OurValuesShapeThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports